import React from 'react';

import './Background.css'
import Pictures from "./Pictures";

const Background = (props) => {


    function bgSet(e) {
       return props.image(e.download_url);

    }


    return (
        <div className="background">
            <label className="bg-secondary text-light w-100">Background</label>
            <Pictures selected={bgSet} />
        </div>
    );
};

export default Background;
